var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconReplicateSuccess = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 58,
  viewBox: "0 0 64 58",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.66667 57.5C4.925 57.5 3.4335 56.8793 2.19217 55.638C0.950833 54.3967 0.331223 52.9062 0.333334 51.1667V6.83334C0.333334 5.09167 0.954 3.60017 2.19533 2.35884C3.43667 1.11751 4.92711 0.497894 6.66667 0.500005H57.3333C59.075 0.500005 60.5665 1.12067 61.8078 2.36201C63.0492 3.60334 63.6688 5.09378 63.6667 6.83334V51.1667C63.6667 52.9083 63.046 54.3998 61.8047 55.6412C60.5633 56.8825 59.0729 57.5021 57.3333 57.5H6.66667ZM9.83333 44.8333H25.6667V38.5H9.83333V44.8333ZM40.075 38.5L55.75 22.825L51.2375 18.3125L40.075 29.5542L35.5625 25.0417L31.1292 29.5542L40.075 38.5ZM9.83333 32.1667H25.6667V25.8333H9.83333V32.1667ZM9.83333 19.5H25.6667V13.1667H9.83333V19.5Z",
  fill: "#119C4A"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconReplicateSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_replicate_success.49f2a178.svg";
export { ForwardRef as ReactComponent };